import React from 'react';
import { POPUP_MESSAGES } from '../constants';
import { PopupMessageProps, PopupMessageConfig } from '../types';

const PopupMessage: React.FC<PopupMessageProps> = ({
  isAuthenticated,
  restrictBrowseAll,
  isTrial,
  onClose,
}) => {
  const getMessageConfig = (): PopupMessageConfig | null => {
    if (!isAuthenticated) return POPUP_MESSAGES.UNAUTHENTICATED;
    if (restrictBrowseAll) return POPUP_MESSAGES.RESTRICTED_BROWSE;
    if (isTrial) return POPUP_MESSAGES.TRIAL;
    return null;
  };

  const messageConfig = getMessageConfig();
  if (!messageConfig) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="w-full text-right pb-2 pr-2" onClick={onClose}>
          X
        </button>
        <p className="text-center text-base">
          {messageConfig.text}{' '}
          <a href={messageConfig.linkUrl} style={{ color: '#D02591' }}>
            {messageConfig.linkText}
          </a>
          {messageConfig.additionalText && (
            <>
              {' '}
              {messageConfig.additionalText}{' '}
              <a href={messageConfig.additionalLinkUrl} style={{ color: '#D02591' }}>
                {messageConfig.additionalLinkText}
              </a>
              .
            </>
          )}
        </p>
      </div>
    </div>
  );
};

export default PopupMessage;